import { Card, Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SettingsInfoInputs from "../../components/SettingsDetails/SettingsInfo/SettingsInfoInputs";
import SettingsLanguages from "../../components/SettingsDetails/SettingsLanguages/SettingsLanguages";
import SettingsPassword from "../../components/SettingsDetails/SettingsPassword/SettingsPassword";
import { useAuthContext } from "../../context/AuthContext";
import styles from "./SettingsDetails.module.css";

import heartImage from "@shltelemedicine/shl-ui-lib/dist/assets/brand/heart.svg"

const contentImgStyle = {
  backgroundImage: `url(${heartImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "250px auto",
  backgroundPosition: "left 1rem top 4.5rem",
};

const SettingsDetails = () => {
  const {
    state: { user },
  } = useAuthContext();

  return (
    <div className={`${styles.wrapper} h-100 w-100`} style={contentImgStyle}>
      <header className={`${styles.header} p-3 `}>
        <p className="mb-0 prim-color">
          <strong>
            <FormattedMessage id="NAV.SETTINGS" defaultMessage="Settings" />
          </strong>
        </p>
      </header>
      <Container className={`${styles.card}`}>
        <Card className="row mb-2 app-shadow px-3 pt-3 pb-2">
          <div className="d-flex px-2">
            <SettingsInfoInputs user={user!} />
          </div>
        </Card>
        <Card className="row mb-2 app-shadow p-3">
          <div className="d-flex px-2">
            <SettingsLanguages />
          </div>
        </Card>
        {!user?.isSso && (
          <Card className="row app-shadow px-3 pt-3 pb-2">
            <div className="d-flex px-2">
              <SettingsPassword />
            </div>
          </Card>
        )}
      </Container>
    </div>
  );
};
export default SettingsDetails;
